import { authenticatedPatch } from '../../../../../../api/request';

export default async function updateSchedules(idDoctorUser, scheduleBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización del horario.');
    const url = `/doctor-profile-management/schedule/${idDoctorUser}`;
    return await authenticatedPatch(url, onFail, scheduleBody);
}
